<template lang="pug">
section
  .d-flex.row.flex-row.align-items-end
    .col-12
      h2 
        i Líderes
  .d-flex.row.flex-row.align-items-start
    .col-12
      .card.p-0.ad_border1-secondary.mb-5.rounded-xl(v-for="(plan, index) in collabsPlans")
        .card-body
          .row.mb-3
            .col
              .h2.mb-3.ad_text-primary
                i {{plan.lider.name}}
              .col-12.p-0
                p.m-0
                  strong(v-if="plan.lider.kpi >= 0") KPI Líder&nbsp;
                  | {{plan.lider.kpi != undefined ? plan.lider.kpi.toFixed(2) + "%": ''}}
                  .col
                    .row
                      strong ICA &nbsp;
                      .input-refresh.d-flex.flex-row.align-items-center
                        input(type="text", maxlength="3", v-model="plan.lider.ica")
                      | &nbsp;% 
                      a.btn(title="Actualizar ICA" @click.stop="updateLiderIca(plan.lider._id, plan.lider.ica)")
                        i.icon-spinner11.ad_text-success.icon--1-2-5x.align-middle                  
            .col-auto.align-self-center
              a.btn(title="Comentarios" @click.stop="openComments(index)")
                i.icono.icono-comentarios.ad_text-primary.fa-2_5x
            .col-auto.align-self-center
              button.btn.py-2.px-3.font-weight-bold(@click="showLiderChange(index)" :class="controlShowLiders[index] ? 'btn-graySecondary' : 'btn-warning text-white'")
                span(v-if="!controlShowLiders[index]")
                  | Mostrar detalle
                  i.fas.fa-chevron-down.ml-2
                span(v-if="controlShowLiders[index]")
                  | Ocultar detalle
                  i.fas.fa-chevron-up.ml-2

          b-collapse.row(v-model="controlShowLiders[index]")
            .col-12.py-2(v-if="plan.weekly_challenge.length > 0")
              table.table-order-less_style.w-100
                thead
                  tr
                    th
                      .h4.font-weight-bold
                        | Desafío semanal
                    th.text-center
                      |
                    th.text-center.px-4(width="10%")
                      .h4.font-weight-bold
                        | Semana
                    th.text-center(width="10%")
                      .h4.font-weight-bold
                        | Cumplimiento
                    th.text-center(width="10%")
                tbody                  
                  tr(v-for="(wc, indexwc) in plan.weekly_challenge")
                    td
                      .col-12.py-2.rounded-xxl.ad_bg-gray
                        span.num_circle.ad_bg-secondary.mr-2
                          | {{indexwc + 1}}
                        | {{wc.description}}   
                    td.text-center
                      | 
                    td.text-center
                      strong {{wc.date | WeekDuratByWeek}}
                        small ta
                    td.text-center
                      div(v-if="wc.accomplished == true")
                        i.icon-checkmark.ad_text-success.icon--1-5x
                      div(v-if="wc.accomplished == false")  
                        i.icon-cross.ad_text-danger.icon--1-5x
                    td(v-if="indexwc == 0 && plan_con.state.order == 0", rowspan="2")
                      a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar", @click.stop="openDesafio(index)" :class="[gestionadoDS ? 'btn-info' : 'btn-secondary']")
                        | {{ refreshDesafio }}
            .col-12.py-2(v-else)
              table.table-order-less_style.w-100
                thead
                  tr
                    th
                      .h4.font-weight-bold
                        | Desafío semanal
                    th.text-center.px-4(width="10%")
                      .h4.font-weight-bold
                        | Semana
                    th.text-center(width="10%")
                      .h4.font-weight-bold
                        | Cumplimiento
                    th.text-center(width="10%")
                tbody
                  tr
                    td
                      .col-12.py-2.rounded-xxl.ad_bg-gray.text-center
                        //.- span.num_circle.ad_bg-secondary.mr-2
                          //.- | - 
                        | No hay desafios personales asignados
                    td.text-center
                      strong --  
                        small ta
                    td.text-center
                      i.icon-blocked.icon--1-5x
                    td(rowspan="2", v-if="plan_con.state.order == 0")
                      a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openDesafio(index)" :class="[gestionadoDS ? 'btn-info' : 'btn-secondary']")
                        | {{ refreshDesafio }}
            hr.w-95.mx-auto.border-top.border-gray

            .col-12.py-2(v-if="plan.kpicon.length > 0")
              table.table-order-less_style.w-100
                thead
                  tr
                    th
                      .h4.font-weight-bold
                        | KPI Adherencia
                    th(width="10%")
                    th(width="10%")
                    th(width="10%")
                tbody                  
                  tr(v-for="(k, indexk) in plan.kpicon")
                    td
                      .row.m-0
                        .col.d-flex.flex-wrap.py-2.rounded-xxl.ad_bg-gray.mr-4
                          .col-auto.pl-0
                            a(id="kpiad2")
                              i.icon-letters.icon-letters__viaje.mr-1 V
                              i.icon-letters.icon-letters__producto.mr-1 P
                              i.icon-letters.icon-letters__segmento.mr-1 S
                              i.icon-letters.icon-letters__negocio.mr-1 N
                            b-tooltip(target="kpiad2" , placement='top')
                              | {{k.travel ? k.travel.name: ''}} + {{k.product ? k.product.name: ''}} + {{k.segemnt ? k.segemnt.name: ''}} + {{k.kpi ? k.kpi.name: ''}}
                            span
                              i.icon-letters.icon-letters__kpi.mr-1 A
                          .col.pl-0
                            | {{k.kpi ? k.kpi.name : ''}}
                        .col-auto.py-2.rounded-xxl.ad_bg-gray
                          | {{k.percentage_business}}%
                    td.text-center
                      strong {{k.date | WeekDuratByWeek}}
                        small ta
                    td.text-center
                      i.icon-checkmark.ad_text-success.icon--1-5x
                    td(v-if="indexk == 0 && plan_con.state.order == 0", rowspan="2")
                      a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openKpi(index)" :class="[gestionadoK ? 'btn-info' : 'btn-secondary']")
                        | {{ refreshKpi }}
            .col-12.py-2(v-else)
              table.table-order-less_style.w-100
                thead
                  tr
                    th
                      .h4.font-weight-bold
                        | KPI Adherencia
                    th(width="10%")
                    th(width="10%")
                    th(width="10%")
                tbody
                  tr
                    td
                      .row.m-0
                        .col.d-flex.flex-wrap.py-2.rounded-xxl.ad_bg-gray.text-center
                          //.- .col-auto.pl-0
                            a(id="kpiad2")
                              i.icon-letters.icon-letters__viaje.mr-1 -
                              i.icon-letters.icon-letters__producto.mr-1 -
                              i.icon-letters.icon-letters__segmento.mr-1 -
                              i.icon-letters.icon-letters__negocio.mr-1 -
                            b-tooltip(target="kpiad2" , placement='top')
                              | Viaje + Producto + Segmento + Negocio
                            span
                              i.icon-letters.icon-letters__kpi.mr-1 -
                          .col.pl-0
                            | No hay kpi asignados
                        //.- .col-auto.py-2.rounded-xxl.ad_bg-gray
                          | --%
                      td.text-center
                        strong --
                          small ta
                      td.text-center
                        i.icon-blocked.icon--1-5x
                      td(rowspan="2", v-if="plan_con.state.order == 0")
                        a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openKpi(index)" :class="[gestionadoK ? 'btn-info' : 'btn-secondary']")
                          | {{ refreshKpi }}
            
            hr.w-95.mx-auto.border-top.border-gray

            .col-12.py-2(v-if="plan.personal_development.length > 0")
              table.table-order-less_style.w-100
                thead
                  tr
                    th
                      .h4.font-weight-bold
                        | Desarrollo personal
                    th
                    th(width="10%")
                    th(width="10%")
                    th(width="10%")  
                tbody                  
                  tr(v-for="(pd, indexpd) in plan.personal_development")
                    td
                      .col-12.py-2.rounded-xxl.ad_bg-gray
                        span.num_circle.ad_bg-secondary.mr-2
                          | {{indexpd + 1}}
                        | {{pd.category.name}}
                    td
                      .col-12.py-2.rounded-xxl.ad_bg-gray
                        | {{pd.subcategory.name}}
                    td.text-center
                      strong {{pd.date | WeekDuratByWeek}}
                        small ta
                    td.text-center
                      i.icon-checkmark.ad_text-success.icon--1-5x
                    td(v-if="indexpd == 0 && plan_con.state.order == 0", rowspan="2")
                      a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openPD(index)" :class="[gestionadoD ? 'btn-info' : 'btn-secondary']")
                        | {{ refreshDesarrollo }}
            .col-12.py-2(v-else)
              table.table-order-less_style.w-100
                thead
                  tr
                    th
                      .h4.font-weight-bold
                        | Desarrollo personal
                    th(width="10%")
                    th(width="10%")
                    th(width="10%")
                tbody
                  tr
                    td
                      .col-12.py-2.rounded-xxl.ad_bg-gray.text-center
                        | No hay desarrollos personales asignados
                    td.text-center
                      strong --
                        small ta
                    td.text-center
                      i.icon-blocked.icon--1-5x
                    td(rowspan="2", v-if="plan_con.state.order == 0")
                      a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openPD(index)" :class="[gestionadoD ? 'btn-info' : 'btn-secondary']")
                        | {{ refreshDesarrollo }}              

      .col-12.py-2.rounded-xl.ad_bg-gray.mb-3(v-if="collabsPlans.length == 0")
        .col-12.text-center.rounded-lg.ad_bg-gray.pt-3
          p.muted No hay Líderes asignados

  v-navigation-drawer(v-model='drawerComentarios', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4(v-if="currentPL")
          i {{ currentPL.lider.name }}
      section.py-4.px-2.overflowy-auto
        .col-12
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(v-model="commentToSend", placeholder="Ingrese comentarios", rows="4")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerComentarios = !drawerComentarios;canContinue(css)")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToLiderPlan('general')")
              span.font-weight-bold Añadir comentario
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          div(v-if="currentPlanComments")  
            div(v-for="c in currentPlanComments")
              .row.mb-3
                .col-4.pr-0
                  p.font-weight-bold.m-0 {{c.user.name}}
                  small.d-block {{c.date | DateFormat}}
                  small.d-block {{c.date | HourFormat}} hrs.
                  small.d-block {{c.type}}
                .col-8.pl-0
                  .dialog-box
                    p {{c.comment}}
            .row.mb-3
              b-pagination(
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage",
                @input="selectedPage('null')",
                class="my-0")  

  v-navigation-drawer(v-model='drawerObjetivos', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4(v-if="currentPL")
          i {{currentPL.lider.name}}
      section.py-4.px-2.overflowy-auto
        .col-12
          .row
            .col-12.d-flex.align-items-center.justify-content-between.py-2
              h3.ad_text-primary.my-2
                i Actividades de Desarrollo Personal
              
          .card.rounded-lg.ad_border1-secondary.p-0.mb-4
            .card-body(v-if="currentPL")
              .row.mb-1
                .col.font-italic.mr-3.d-flex.justify-content-between
                  span Competencia
                .col.font-italic.mr-3.d-flex.justify-content-between
                  span Actividad
                  span
                .col-3.font-italic.text-center
                  span Cumple
                .col-1
              .row.desafios-semanales(v-if="currentPL.personal_development.length > 0")
                .col-12.ad_text-dangerDark(v-if="errorPD")
                  p.ad_bg-dangerLight.px-3.py-2.rounded
                    i.fas.fa-times-circle.mr-1
                    | Debe seleccionar si se cumplió o no este Objtivo de Desarrollo
                .col-12.d-flex.flex-row(v-for="(pd, ind) in currentPL.personal_development")
                  .col.pl-0.py-3.border-bottom
                    .row.ad_bg-gray.rounded-xl.py-3.m-0
                      .w-75.px-3
                        | {{pd.category.name}}
                  .col.pl-0.py-3.border-bottom
                    .row.ad_bg-gray.rounded-xl.py-3.m-0                      
                      .w-75.px-3
                        | {{pd.subcategory.name}}
                      .w-25.px-3.text-right
                        strong {{pd.date | WeekDuration}}ta 
                        i sem
                  .col-auto.d-flex.px-0.py-3.border-bottom.align-items-center.justify-content-around
                    c-form-radio.mr-2.ad_radio.ad_radio-cumple(:name="'pd' + ind" v-model="accomplishedPD[ind]" value="true" label="Si")
                    c-form-radio.ml-2.ad_radio.ad_radio-nocumple(:name="'pd' + ind" v-model="accomplishedPD[ind]" value="false" label="No")
                  .col-auto.pr-0.py-3.d-flex.align-items-center.border-bottom
                    button.btn.btn__small.btn-secondary-border.font-weight-bold(@click.stop="showCloseConfirm('closePD', 'el Desarrollo', pd, currentPL._id, ind)")
                      | Cerrar
              .row.d-flex.justify-content-center.my-3
                .col-auto(v-if="currentPL")
                  b-button.btn.btn__medium.btn-success.py-2.w-100(@click="objetivodp = !objetivodp")
                    i.fas.fa-plus-circle.mr-1
                    span.m-0.font-weight-bold Añadir Objetivo de Desarrollo Personal
              b-collapse(v-model="objetivodp" id="objetivoDP")
                .card.py-0.border-0.rounded-xl.ad_bg-gray
                  .card-body
                    .row
                      .col-12
                        .h5.font-weight-bold.font-italic
                          | Crear Nueva Competencia
                        .form-group.ad_select
                          select(v-model='selectedCategoria', @change='getSubByCat($event)')
                            option(value="null" selected) Selecciona competencia
                            option(:value="category" v-for="category in categories") {{category.name}}
                        .form-group.ad_select
                          select(v-model='selectedSubcategoria')
                            option(value="null" selected) Selecciona actividad
                            option(:value="objetivo" v-for="objetivo in subcategories") {{objetivo.name}}
                        .row.mt-4.mb-2
                          .col.d-flex.justify-content-between
                            button.btn.btn-graySecondary-border.btn__medium
                              i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                              span.ad_text-grayMedio Cancelar
                            button.btn.btn-success-border.btn__medium
                              span.font-weight-bold.pl-2(@click="createPDCon()") Crear
                              i.fas.fa-plus-circle.ml-1
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerObjetivos = !drawerObjetivos")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="showUpdateConfirm('updatePD', 'los desarrollos personales')")
              span.font-weight-bold Grabar
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          c-scroll-view(style="height:300px;")
            div(v-if="currentPlanComments")  
              div(v-for="c in currentPlanComments")
                .row.mb-3
                  .col-4.pr-0
                    p.font-weight-bold.m-0 {{c.user.name}}
                    small.d-block {{c.date | DateFormat}}
                    small.d-block {{c.date | HourFormat}} hrs.
                    small.d-block {{c.type}}
                  .col-8.pl-0
                    .dialog-box
                      p {{c.comment}}
              .row.mb-3
                b-pagination(
                  v-model="currentPageDp"
                  :total-rows="totalRowsDp"
                  :per-page="perPage",
                  @input="selectedPage('Desarrollo Personal')",
                  class="my-0")
  v-navigation-drawer(v-model='drawerDesafio', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4(v-if="currentPL")
          i {{currentPL.lider.name}}
      section.py-4.px-2.overflowy-auto
        .col-12          
          .row
            .col-12.d-flex.align-items-center.justify-content-between.py-2
              h3.ad_text-primary.my-2
                i Desafíos semanales

          .card.rounded-lg.ad_border1-secondary.p-0.mb-4
            .card-body(v-if="currentPL")
              .row.mb-1
                .col.pr-0.font-italic.d-flex.justify-content-between
                  span Desafíos
                  span Semana
                .col-3.font-italic.text-center
                  span Cumple
                .col-1
              .row.desafios-semanales(v-if="currentPL.weekly_challenge.length > 0")
                .col-12.ad_text-dangerDark(v-if="errorWC")
                  p.ad_bg-dangerLight.px-3.py-2.rounded
                    i.fas.fa-times-circle.mr-1
                    | Debe seleccionar si se cumplió o no este Desafío
                .col-12.d-flex.flex-row(v-for="(wc, inde) in currentPL.weekly_challenge")
                  .col.pl-0.py-3.border-bottom.w-75
                    .row.ad_bg-gray.rounded-xl.py-3.m-0
                      .w-75.px-3
                        | {{wc.description}}
                      .w-25.px-3.text-right
                        strong {{wc.date | WeekDuration}}ta 
                        i sem
                  .col-auto.d-flex.px-0.py-3.border-bottom.align-items-center.justify-content-around.w-25
                    c-form-radio.mr-2.ad_radio.ad_radio-cumple(:name="'desafio' + inde" v-model="accomplishedWC[inde]" value="true" label="Si", v-if="wc._id")
                    c-form-radio.ml-2.ad_radio.ad_radio-nocumple(:name="'desafio' + inde" v-model="accomplishedWC[inde]" value="false" label="No", v-if="wc._id")
                  .col-auto.pr-0.py-3.d-flex.align-items-center.border-bottom.w-25
                    button.btn.btn__small.btn-secondary-border.font-weight-bold(@click.stop="showCloseConfirm('closeWC', 'el Desafío', wc, currentPL._id, inde)")
                      | Cerrar
              .row.d-flex.justify-content-center.my-3
                .col-auto(v-if="currentPL")
                  b-button.btn.btn__medium.btn-success.py-2.w-100(@click="adddesafio = !adddesafio")
                    i.fas.fa-plus-circle.mr-1
                    span.m-0.font-weight-bold Añadir Desafío Semanal
              b-collapse(v-model="adddesafio" id="newDesafio")
                .h5.font-weight-bold.font-italic.mt-4
                  | Nuevo Desafío
                .card.py-0.border-0.rounded-xl.ad_bg-gray
                  .card-body
                    .form-group.row.align-items-center
                      textarea.form-control(placeholder="Ingrese desafío", rows="4", v-model="wcdescription")
                    .form-group.d-flex.row.align-items-center.justify-content-between.mt-4.mb-2
                      .col.d-flex.px-0.justify-content-between
                        button.btn.btn-graySecondary-border.btn__medium(@click="adddesafio = !adddesafio")
                          i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                          span.ad_text-grayMedio Cancelar
                        button.btn.btn-success-border.btn__medium(@click.stop="createWCCon()")
                          span.font-weight-bold.pl-2 Crear
                          i.fas.fa-plus-circle.ml-1
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerDesafio = !drawerDesafio")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="showUpdateConfirm('upadteWC', 'los Desafios semanales')")
              span.font-weight-bold Grabar
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          div(v-if="currentPlanComments")  
            div(v-for="c in currentPlanComments")
              .row.mb-3
                .col-4.pr-0
                  p.font-weight-bold.m-0 {{c.user.name}}
                  small.d-block {{c.date | DateFormat}}
                  small.d-block {{c.date | HourFormat}} hrs.
                  small.d-block {{c.type}}
                .col-8.pl-0
                  .dialog-box
                    p {{c.comment}}
            .row.mb-3
              b-pagination(
                v-model="currentPageDs"
                :total-rows="totalRowsDs"
                :per-page="perPage",
                @input="selectedPage('Desafio Semanal')",
                class="my-0")
  v-navigation-drawer(v-model='drawerKpi', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4(v-if="currentPL")
          i {{currentPL.lider.name}}
      section.py-4.px-2.overflowy-auto
        .col-12          
          .row
            .col-12.d-flex.align-items-center.justify-content-between.py-2
              h3.ad_text-primary.my-2
                i KPIs Adherencia

          .card.rounded-lg.ad_border1-secondary.p-0.mb-4
            .card-body(v-if="currentPL")
              .kpi-adherencia.mb-2.border-bottom(v-for="(k, indek) in currentPL.kpicon")
                .row
                  .col.font-italic
                    h3.font-weight-bold KPIs
                  .col.text-right
                    h3 {{k.date | WeekDuration}}ta 
                      small semana
                .row.justify-content-end.mb-1
                  .col-12
                    .row.ad_bg-gray.rounded-lg.py-3.m-0
                      .col-12.mb-3
                        i.icon-letters.icon-letters__viaje.mr-1  V
                        span {{k.travel ? k.travel.name: ''}}
                      .col-12.mb-3
                        i.icon-letters.icon-letters__producto.mr-1 P 
                        span {{k.product ? k.product.name: ''}}
                      .col-12.mb-3
                        i.icon-letters.icon-letters__segmento.mr-1 S
                        span {{k.segment ? k.segment.name: ''}}
                      .col-12.d-flex.flex-nowrap.mb-3
                        .w-75
                          i.icon-letters.icon-letters__negocio.mr-1 N
                          span {{k.business_type ? k.business_type.name: ''}}
                        .w-25.text-right
                          | {{k.percentage_business}}%
                          a#kpinegocio
                            i.fas.fa-info-circle.ad_text-secondary.ml-1
                          b-tooltip(target="kpinegocio" , placement='top')
                            | % de Cumplimiento del KPI de Negocio
                      .col-12.d-flex.flex-nowrap.mb-3
                        .w-75
                          i.icon-letters.icon-letters__kpi.mr-1 A
                          span {{k.kpi ? k.kpi.name: ''}}
                        .w-25.text-right
                          | {{k.percentage_adherence}}%
                          a#kpiadherencia
                            i.fas.fa-info-circle.ad_text-secondary.ml-1
                          b-tooltip(target="kpiadherencia" , placement='top')
                            | % de Cumplimiento del KPI de Adherencia
                      
                .row.d-flex.justify-content-center.my-3(v-if="k._id")
                  .col-12.ad_text-dangerDark(v-if="errorK")
                    p.ad_bg-dangerLight.px-3.py-2.rounded
                      i.fas.fa-times-circle.mr-1
                      | Debe seleccionar si se cumplió o no este KPI
                  .col.d-flex.align-items-center.justify-content-end
                    label.font-weight-bold.h5.m-0.pr-2 Cumple:
                    c-form-radio.ad_radio.ad_radio-cumple.pr-3(:name="'kpi' + indek" v-model="accomplishedK[indek]" value="true" label="Si")
                    c-form-radio.ad_radio.ad_radio-nocumple(:name="'kpi' + indek" v-model="accomplishedK[indek]" value="false" label="No")
                  .col-4
                    button.btn.btn__medium.btn-secondary-border.py-2.w-100(@click.stop="closeKpiConsultor(k, currentPL._id, indek)")
                      span.m-0.font-weight-bold Cerrar
              
              .row.d-flex.justify-content-center.my-3
                .col-auto(v-if="currentPL")
                  b-button.btn.btn__medium.btn-success.py-2.w-100(@click="newKPI = !newKPI")
                    i.fas.fa-plus-circle.mr-1
                    span.m-0.font-weight-bold Añadir KPI Adherencia
              b-collapse(v-model="newKPI" id="addkpi")
                h3.ad_text-grayMedio.mb-2
                  i Nuevo KPI Adherencia
                .card.py-0.border-0.rounded-xl.ad_bg-gray
                  .card-body
                    .form-group.row.align-items-center
                      .col-auto.pl-0.pr-2
                        i.icon-letters.icon-letters__viaje.mr-1 V
                      .col.px-0.ad_select
                        select(v-model='selectedViaje', @change='getSegments($event)')
                          option(:value="null" disabled) Selecciona viaje
                          option(:value="travel", v-for="travel in travels", :key="travel._id") {{travel.name}}
                    .form-group.row.align-items-center
                      .col-auto.pl-0.pr-2
                        i.icon-letters.icon-letters__segmento.mr-1 S
                      .col.px-0.ad_select(:class='{disabled : !selectedViaje }')
                        select(v-model="selectedSegmento", :disabled='!selectedViaje', @change='getProducts($event)')
                          option(:value="null" disabled) Selecciona segmento
                          option(:value="segment" v-for="segment in segments" :key="segment._id") {{segment.name}}
                    .form-group.row.align-items-center
                      .col-auto.pl-0.pr-2
                        i.icon-letters.icon-letters__producto.mr-1 P
                      .col.px-0.ad_select(:class='{disabled : !selectedSegmento }')
                        select(v-model="selectedProducto", :disabled='!selectedSegmento', @change='getBusinessTypes($event) + getKpisByIds($event)')
                          option(:value="null" disabled) Selecciona Producto
                          option(:value="product" v-for="product in products" :key="product._id") {{product.name}}
                    .form-group.d-flex.row.align-items-center.justify-content-between
                      .col-auto.px-0
                        i.icon-letters.icon-letters__negocio.mr-1 N
                      .col.d-flex.col-9.p-0
                        .ad_select(:class='{disabled : !selectedProducto }')
                          select(v-model='selectedKpiNegocio', :disabled='!selectedProducto', @change='setPorcentage($event)')
                            option(:value="null" disabled) Selecciona KPI Negocio
                            option(:value="business" v-for="business in businesstypes" :key="business._id") {{business.name}}
                      .d-flex.col-auto.pr-0.d-flex.align-items-stretch
                        .d-flex.ad_text-grayMedio.text-center.w-100
                          .input-refresh.d-flex.flex-row.align-items-center.ml(:class='{disabled : !selectedProducto }')
                            input(type="text" v-model="percentageBusiness" :disabled='!selectedProducto' max='100' maxlength='3')
                            | %
                            a#kpinegocio(href="#")
                              i.fas.fa-info-circle.ad_text-secondary.ml-1
                            b-tooltip(target="kpinegocio" , placement='top')
                              | % de Cumplimiento del KPI de Negocio obtenido la semana pasada
                    .form-group.d-flex.row.align-items-center.justify-content-between
                      .col-auto.px-0
                        i.icon-letters.icon-letters__kpi.mr-1 A
                      .col.d-flex.col-9.p-0
                        .ad_select(:class='{disabled : !selectedKpiNegocio }')
                          select(v-model='selectedKpiAdherencia' :disabled='!selectedKpiNegocio')
                            option(:value="null" disabled) Selecciona KPI Adherencia
                            option(:value="kpi" v-for="kpi in kpis" :key="kpi._id") {{kpi.name}}
                      .d-flex.col-auto.pr-0.d-flex.align-items-stretch
                        .d-flex.ad_text-grayMedio.text-center.w-100
                          .input-refresh.d-flex.flex-row.align-items-center.ml-2(:class='{disabled : !selectedKpiNegocio }')
                            input(type="text" v-model="percentageAdherence" :disabled='!selectedKpiNegocio' max='100' maxlength='3')
                            | %
                            a#kpiadherencia(href="#")
                              i.fas.fa-info-circle.ad_text-secondary.ml-1
                            b-tooltip(target="kpiadherencia" , placement='top')
                              | % de Cumplimiento del KPI de Adherencia obtenido la semana pasada
                    .form-group.d-flex.row.align-items-center.justify-content-between.mt-4.mb-2
                      .col.d-flex.px-0.justify-content-between
                        button.btn.btn-graySecondary-border.btn__medium(@click="newKPI = !newKPI")
                          i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                          span.ad_text-grayMedio Cancelar
                        button.btn.btn-success-border.btn__medium
                          span.font-weight-bold.pl-2(@click.stop="createKpiCon()") Crear
                          i.fas.fa-plus-circle.ml-1
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerKpi = !drawerKpi")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="showUpdateConfirm('updateK','los Kpi')")
              span.font-weight-bold Grabar
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          div(v-if="currentPlanComments")  
            div(v-for="c in currentPlanComments")
              .row.mb-3
                .col-4.pr-0
                  p.font-weight-bold.m-0 {{c.user.name}}
                  small.d-block {{c.date | DateFormat}}
                  small.d-block {{c.date | HourFormat}} hrs.
                  small.d-block {{c.type}}
                .col-8.pl-0
                  .dialog-box
                    p {{c.comment}}
            .row.mb-3
              b-pagination(
                v-model="currentPageK"
                :total-rows="totalRowsK"
                :per-page="perPage",
                @input="selectedPage('Kpi')",
                class="my-0")
  
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "ConsLiderAsigExt",
  props: ["clickedNext", "currentStep"],
  components: {},
  data() {
    return {
      accomplishedWC: [],
      accomplishedPD: [],
      accomplishedK: [],
      adddesafio: false,
      businesstypes: [],
      categories: [],
      collabs: null,
      collabsPlans: [],
      controlShowLiders: [],
      commentToSend: null,
      currentPlanComments: [],            
      currentWC: {},
      currentPL: null,
      currentPLindex: null,
      currentKpi: {},
      currentPD: {},
      currentPage: 1,
      currentPageDs: 1,     
      currentPageDp: 1,
      currentPageK: 1,
      drawerComentarios: null,
      drawerDesafio: null,
      drawerKpi: null,
      drawerObjetivos: null,
      errorWC: false,
      errorPD: false,
      errorK: false,
      gestionadoD: false,
      gestionadoK: false,
      gestionadoDS: false,
      kpis: [],
      newKPI: false,
      overlay: false,            
      objetivodp: false,
      pddescription: null,
      percentageAdherence: 0,
      percentageBusiness: 0,
      perPage: 5,
      plan_con: null,
      products: [],
      registroNegocio: null,                
      registroAdherencia: null,
      refreshDesarrollo: 'Actualizar',
      refreshKpi: 'Actualizar',
      refreshDesafio: 'Actualizar',
      selectedKpiNegocio: null,
      selectedKpiAdherencia: null,
      selectedCategoria: null,
      selectedSubcategoria: null,
      selectedSegmento: null,
      selectedViaje: null,      
      selectedProducto: null,
      segments: [],
      states: [],
      subcategories: [],          
      travels: [],
      totalRows: 0,
      totalPages: 0,
      totalRowsDp: 0,
      totalRowsDs: 0,
      totalRowsK: 0,
      totalPagesDp: 0,
      totalPagesDs: 0,
      totalPagesK: 0,
      user: null,     
      wcdescription: null      
    };
  },
  methods: {
    ...mapActions('plan_lider', [
      'collabsPlanWeekInfo', 'addComment', 'createIfDontExist', 'getCommentsByPLanId'
    ]),
    ...mapActions('kpicon', [
      'createKPIC', 'closeKpiCon', 'updateBKpiCon'
    ]),
    ...mapActions('personaldevelopment', [
      'createPDC', 'closePersonalDevelopment', 'updateBPersonalDevelopment'
    ]),
    ...mapActions('weeklychallenge', [
      'createWC', 'closeWeeklyChallenge', 'updateBWeeklyChallenge'
    ]),
    ...mapActions('travel', [
      'travelList', 'getTravelById', 'getTravelsByRoles'
    ]),
    ...mapActions('segment', [
      'ByTravelId', 'getSegmentById', 'getSegmentByRoles'
    ]),
    ...mapActions('product', [
      'BySegmentId', 'getProductById', 'getProductByRoles'
    ]),
    ...mapActions('businesstype', [
      'businessTypeByIds', 'businessBySegTraProd'
    ]),
    ...mapActions('kpi', [
      'kpiByIds', 'getKpiById'
    ]),
    ...mapActions('category', [
      'categoriesList', 'getCatById'
    ]),
    ...mapActions('subcategory', [
      'byCategoryId', 'getSubcatById'
    ]),
    ...mapActions('State', [
      'statesList'
    ]),
    ...mapActions('user', [
      'updateIca'
    ]),
    ...mapActions('businesstype', [
      'businessTypeById'
    ]),
    ...mapActions('comments_plancon', [
      'getCommentsByPlanLider', 'createCommentPlanCon'
    ]),
    ...mapActions('role', [
      'byTriplets'
    ]),
    canContinue () {
      if (this.gestionadoDS && this.gestionadoK && this.gestionadoD) {
        this.$emit('can-continue', {value: true})
      }
    },
    canContinueDesarrollo () {
      if (this.gestionadoDS && this.gestionadoK) {
        this.$emit('can-continue', {value: true})
      }
      this.refreshDesarrollo = this.refreshDesarrollo.replace("Actualizar", "Gestionado")
      this.gestionadoD = true
      return this.gestionadoD
    },
    canContinueKpi (css) {
      if (this.gestionadoDS && this.gestionadoD) {
        this.$emit('can-continue', {value: true})
      }
      this.refreshKpi = this.refreshKpi.replace("Actualizar", "Gestionado")
      this.gestionadoK = true
      return this.gestionadoK
    },
    canContinueDesafio () {
      if (this.gestionadoD && this.gestionadoK) {
        this.$emit('can-continue', {value: true})
      }
      this.refreshDesafio = this.refreshDesafio.replace("Actualizar", "Gestionado")
      this.gestionadoDS = true
      return this.gestionadoDS
    },
    showLiderChange: function(index) {
      const vm = this
      let sp = vm.controlShowLiders[index] ? false : true
      vm.controlShowLiders.splice(index, 1, sp)      
    },
    openComments: function(index) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.collabsPlans[index]      
      vm.getComments(null).then(() => {
        loading.hide()
        vm.drawerComentarios = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })                
    },
    addCommentToLiderPlan: function(type) {
      const vm = this
      return new Promise((resolve, reject) => {
        if (vm.commentToSend != null) {
          let varPag = '';

          if (type == 'Desafio Semanal') {
            varPag = 'Ds'
          } else if (type == 'Desarrollo Personal') {
            varPag = 'Dp'
          } else if (type == 'Kpi') {
            varPag = 'K'
          }

          const data = {
            plan_lider: vm.currentPL._id,
            user: vm.user.id,
            type: type,
            date: moment(),
            comment: vm.commentToSend
          }

          vm.createCommentPlanCon(data).then((response) => {
            vm.commentToSend = null
            let res = vm.$store.getters['comments_plancon/getComments']
            vm.currentPlanComments = res.docs            
            vm[`totalRows${varPag}`] = res.total
            vm[`totalPages${varPag}`] =  res.totalPages
            resolve()
          }, (error) => {
            console.log(error)
            reject(error)
          })
        } else {
          resolve()
        }
      })      
    },
    addAutoCommentToLiderPlan: function(type, autocomment) {
      const vm = this
      return new Promise((resolve, reject) => {
        const data = {
          plan_lider: vm.currentPL._id,
          user: vm.user.id,
          type: type,
          date: moment(),
          comment: autocomment
        }
        vm.createCommentPlanCon(data).then((response) => {
          // vm.currentPlanComments = vm.$store.getters['comments_plancon/getComments']
          resolve()
        }, (error) => {
          console.log(error)
          reject(error)
        })
      })      
    },
    createKpiCon: function () {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      // if (vm.currentPL.kpicon.length < 2) {
        if (vm.selectedKpiAdherencia && vm.percentageBusiness && vm.percentageAdherence) {
          vm.currentPL.kpicon.push({
            plan_lider: vm.currentPL._id,
            plan_con: vm.plan_con._id,
            date: moment(),
            percentage_business: vm.percentageBusiness,
            percentage_adherence: vm.percentageAdherence,
            kpi: vm.selectedKpiAdherencia,
            business_type: vm.selectedKpiNegocio,
            segment: vm.selectedSegmento,
            travel: vm.selectedViaje,
            product: vm.selectedProducto,
            accomplished: false
          })
          vm.percentageBusiness = 0
          vm.percentageAdherence = 0
          vm.selectedKpiAdherencia = null
          vm.selectedSegmento = null
          vm.selectedViaje = null
          vm.selectedProducto = null
          vm.newKPI = false     
          loading.hide()
        } else {          
          loading.hide()
          vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe completar todos los datos en el formulario.',
          closeable: true,
          duration: 5000
        })
        }
      // } else {
      //   vm.drawerKpi = false
      //   loading.hide()
      //   vm.$notify({
      //     type: 'danger',
      //     title: 'Notificación',
      //     content: 'No puede agregar mas de dos kpis',
      //     closeable: true,
      //     duration: 5000
      //   })
      // }
    },
    createWCCon: function ($event) {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      // if (vm.currentPL.weekly_challenge.length < 2) {
        if (vm.wcdescription) {
          vm.currentPL.weekly_challenge.push({
            description: vm.wcdescription,
            plan_lider: vm.currentPL._id,
            plan_con: vm.plan_con._id,
            date: moment(),
            accomplished: false
          })
          vm.wcdescription = null
          vm.adddesafio = false     
          loading.hide()
        } else {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe completar el formulario.',
            closeable: true,
            duration: 5000
          })
        }
      // } else {
      //   vm.drawerDesafio = false
      //   loading.hide()
      //   vm.$notify({
      //     type: 'danger',
      //     title: 'Notificación',
      //     content: 'No puede agregar mas de dos desafios.',
      //     closeable: true,
      //     duration: 5000
      //   })
      // }
    },
    createPDCon: function () {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      // if (vm.currentPL.personal_development.length < 2) {
        if (vm.selectedCategoria && vm.selectedSubcategoria) {
          vm.currentPL.personal_development.push({
            description: vm.pddescription,
            plan_lider: vm.currentPL._id,
            plan_con: vm.plan_con._id,
            date: moment(),
            category: vm.selectedCategoria,
            subcategory: vm.selectedSubcategoria,
            accomplished: false
          })
          vm.pddescription = null
          vm.objetivodp = false     
          loading.hide()
        } else {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe completar el formulario',
            closeable: true,
            duration: 5000
          })
        }
      // } else {
      //   vm.drawerObjetivos = false
      //   loading.hide()
      //   vm.$notify({
      //     type: 'danger',
      //     title: 'Notificación',
      //     content: 'No puede agregar mas de dos desarollo personal',
      //     closeable: true,
      //     duration: 5000
      //   })
      // }
    },
    openDesafio: function (planindex) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.collabsPlans[planindex]
      vm.currentPLindex = planindex
      vm.getComments('Desafio Semanal').then(() => {
        loading.hide()
        vm.drawerDesafio = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })      
    },
    openKpi: function (planindex) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.collabsPlans[planindex]
      vm.currentPLindex = planindex
      vm.travelsByRole().then(() => {
        vm.getComments('Kpi').then(() => {
          loading.hide()
          vm.drawerKpi = true
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (e) => {
        console.info(e)
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    openPD: function (planindex) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.collabsPlans[planindex]
      vm.currentPLindex = planindex   
      vm.getComments('Desarrollo Personal').then(() => {
        loading.hide()
        vm.drawerObjetivos = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      }) 
    },
    notEmptyObject: function (someObject) {
      const vm = this
      return Object.keys(someObject).length      
    },
    getSegments($event) {
      const vm = this
      const loading = vm.$toast.loading('Cargando segmentos...')
      vm.selectedProducto = null
      vm.selectedKpiNegocio = null
      vm.selectedKpiAdherencia = null
      vm.registroNegocio = 0
      vm.registroAdherencia = 0
      vm.getSegmentByRoles({roles: vm.currentPL.lider.role, travel: vm.selectedViaje._id}).then(() => {
        vm.segments = vm.$store.getters['segment/getSegments']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getProducts($event) {
      const vm = this
      vm.selectedKpiNegocio = null
      vm.registroNegocio = 0
      vm.registroAdherencia = 0
      vm.selectedKpiAdherencia = null
      const loading = vm.$toast.loading('Cargando productos...')
      vm.getProductByRoles({roles: vm.currentPL.lider.role, segment: vm.selectedSegmento._id}).then(() => {
        vm.products = vm.$store.getters['product/getProducts']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getBusinessTypes($event) {
      const vm = this
      vm.selectedKpiAdherencia = null
      vm.registroAdherencia = 0
      const loading = vm.$toast.loading('Cargando kpis de negocio...')
      vm.businessBySegTraProd({
        segment: vm.selectedSegmento._id, 
        travel: vm.selectedViaje._id,
        product: vm.selectedProducto._id 
      }).then(() => {
        vm.businesstypes = vm.$store.getters['businesstype/getBusinessType']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getKpisByIds($event) {
      const vm = this
      const loading = vm.$toast.loading('Cargando kpis de adherencia...')
      vm.byTriplets({
        travel: vm.selectedViaje._id, 
        segment: vm.selectedSegmento._id, 
        product: vm.selectedProducto._id
      }).then((roles) => {
        //filtrar por role de usuarios.
        let rolesFiltered = []
        let rolesForFilter = vm.currentPL.lider.role
        if (roles.length > 0) { 
          for (let r of roles) {
            for (let ur of rolesForFilter) {
              if (r._id.toString() == ur) {
                rolesFiltered.push(r)
              }
            }
          }
        }
        vm.kpiByIds({ role: rolesFiltered}).then(() => {
          vm.kpis = vm.$store.getters['kpi/getKpis']
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    getTravels() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.travelList({ids: vm.currentPL.lider.travel}).then(() => {
          vm.travels = vm.$store.getters['travel/getTravels']
          resolve()
        }, (error) => {
          reject()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      })      
    },
    getCategories() {
      const vm = this
      vm.categoriesList().then(() => {
        vm.categories = vm.$store.getters['category/getCategories']
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    getSubByCat() {
      const vm = this
      if (vm.selectedCategoria) {
        vm.byCategoryId(vm.selectedCategoria._id).then(() => {
          vm.subcategories = vm.$store.getters['subcategory/getSubcategories']
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }
    },
    updPL(plan, reference, doc) {
      const vm = this
      for (let index in vm.collabsPlans) {
        if (vm.collabsPlans[index]._id == plan._id) {
          vm.collabsPlans[index][reference].push(doc)
        }
      }
    },
    closeWC(wc, planid, inde) {
      const vm = this
      const loading = vm.$toast.loading('Cerrando...')
      if (vm.accomplishedWC[inde] != null) {
        let accomplishedText = vm.accomplishedWC[inde] ? 'cumplido': 'no cumplido'
        let autocomm = `Cierre desafio ${wc.description}, ${accomplishedText}`
        vm.currentWC = vm.collabsPlans[vm.currentPLindex].weekly_challenge[inde]
        
        vm.addAutoCommentToLiderPlan('Desafio Semanal', autocomm).then(() => {
          vm.closeWeeklyChallenge({id: wc._id, planid: planid, accomplished: vm.accomplishedWC[inde]}).then(() => {
            vm.removeFromUIList('weekly_challenge')
            vm.drawerDesafio = false
            vm.errorWC = false
            vm.accomplishedWC = []
            loading.hide()
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })        
      } else {
        vm.errorWC = true
        loading.hide()
      }
    },
    closePD(pd, planid, ind) {
      const vm = this
      const loading = vm.$toast.loading('Cerrando...')
      if (pd._id) {
        if (vm.accomplishedPD[ind] != null) {
          let accomplishedText = vm.accomplishedPD[ind] ? 'cumplido': 'no cumplido'
          let autocomm = `Cierre competencia personal ${pd.subcategory.name}, ${accomplishedText}`
          vm.currentPD = vm.collabsPlans[vm.currentPLindex].personal_development[ind]

          vm.addAutoCommentToLiderPlan('Desarrollo Personal', autocomm).then(() => {
            vm.closePersonalDevelopment({id: pd._id, planid: planid, accomplished: vm.accomplishedPD[ind]}).then((response) => {
              vm.removeFromUIList('personal_development')
              vm.drawerObjetivos = false
              vm.errorPD = false
              vm.accomplishedPD = []
              loading.hide()
            }, (error) => {
              loading.hide()
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: error.payload.message,
                closeable: true,
                duration: 5000
              })      
            })
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        } else {
          vm.errorPD = true
          loading.hide()
        }
      } else {
        vm.removeFromUIList('personal_development')
        loading.hide()
      }
    },
    closeKpiConsultor(k, planid, ind) {
      const vm = this
      const loading = vm.$toast.loading('Cerrando...')
      if (vm.accomplishedK[ind] != null) {
        let accomplishedText = vm.accomplishedK[ind] ? 'cumplido': 'no cumplido'
        let autocomm = `Cierre kpi ${k.kpi.name}, ${accomplishedText}`
        vm.currentKpi = vm.collabsPlans[vm.currentPLindex].kpicon[ind]

        vm.addAutoCommentToLiderPlan('Kpi', autocomm).then(() => {
          vm.closeKpiCon({id: k._id, planid: planid, accomplished: vm.accomplishedK[ind]}).then((response) => {
            vm.removeFromUIList('kpicon')
            vm.drawerKpi = false
            vm.errorK = false
            vm.accomplishedK = []
            loading.hide()
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })      
          })
        }, (error) => {
          loading.hide()
          console.log(error)
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.errorK = true
        loading.hide()
      }
    },
    removeFromUIList(namespace, indcurrent) {
      const vm = this
      let currentObject = ''
      switch (namespace) {
        case 'weekly_challenge':
          currentObject = 'currentWC'
          break
        case 'kpicon':
          currentObject = 'currentKpi'
          break
        case 'personal_development':
          currentObject = 'currentPD'
          break
      }
      for (let index in vm.collabsPlans) {
        if (vm.collabsPlans[index]._id == vm.currentPL._id) {
          for (let indexw in vm.collabsPlans[index][namespace]) {
            if (vm.collabsPlans[index][namespace][indexw]._id == vm[currentObject]._id) {
              vm.collabsPlans[index][namespace].splice(indexw, 1)
            }
          }
        }
      }
    },
    getComments(type) {
      return new Promise ((resolve, reject) => {
        const vm = this
        if (vm.notEmptyObject('currentPL')) {

          let varPag = ''
          if (type == 'Desafio Semanal') {
            varPag = 'Ds'
          } else if (type == 'Desarrollo Personal') {
            varPag = 'Dp'
          } else if (type == 'Kpi') {
            varPag = 'K'
          }

          vm.getCommentsByPlanLider({id: vm.currentPL._id, type: type, pagination: {page: vm[`currentPage${varPag}`], perPage: vm.perPage}}).then(() => {
            let res = vm.$store.getters['comments_plancon/getComments']
            vm.currentPlanComments = res.docs            
            vm[`totalRows${varPag}`] = res.total
            vm[`totalPages${varPag}`] =  res.totalPages
            resolve()
          }, (error) => {
            reject(error)
          })
        } else {
          resolve()
        }
      })      
    },
    selectedPage(type) {
      const vm = this
      vm.getComments(type).then(() => {
        loading.hide()
        vm.drawerObjetivos = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    checkManagment() {
      const vm = this
      let complete = true
      for (let c of vm.collabsPlans) {
        if (c.kpicon.length <= 1 ||
          c.personal_development.length <= 1 ||
          c.weekly_challenge.length <= 1) {
          complete = false
        }
      }
      
      vm.$emit('completed-step', {value: true});
      vm.$emit("can-continue", { value: true });
      // if (complete) {
      //   this.$emit('completed-step', {value: true});
      //   vm.$emit("can-continue", { value: true });
      // } else {
      //   vm.$emit("can-continue", { value: false });
      // }
    },
    addControlLider() {
      const vm = this
      for (let index in vm.collabsPlans) {
        vm.controlShowLiders.push(false)
      }
    },
    getsCatPdPerPlan(index) {
      return new Promise((res, rej) => {
        const vm = this
        let findingCat = function(pd, indexw) {          
          return new Promise((resolve, reject) => {
            vm.getCatById(pd.category).then((category) => {
              vm.collabsPlans[index].personal_development[indexw].category = category 
              for (let s of vm.states) {
                if (vm.collabsPlans[index].personal_development[indexw].state == s._id) {
                  vm.collabsPlans[index].personal_development[indexw].state = s
                }
              }
              resolve()
            }, (error) => {
              console.info(error)
              reject(error)
            })
          })
        }

        let actionsC = vm.collabsPlans[index].personal_development.map(findingCat)
        let results = Promise.all(actionsC)
        results.then(() => {
          res()
        }, (err) => {
          rej(err)
        })
      })      
    },
    getsSubcatPdPerPlan(index) {
      return new Promise((res, rej) => {
        const vm = this
        let findingSubcat = function(pd, indexw) {
          return new Promise((resolve, reject) => {
            vm.getSubcatById(pd.subcategory).then((subcategory) => {
              vm.collabsPlans[index].personal_development[indexw].subcategory = subcategory
              resolve()
            }, (error) => {
              console.info(error)
              reject(error)
            })
          })
        }

        let actionsS = vm.collabsPlans[index].personal_development.map(findingSubcat)
        let results = Promise.all(actionsS)
        results.then(() => {
          res()
        }, (err) => {
          rej(err)
        })
      })      
    },
    getsKpisPerPlan(index) {
      return new Promise((res, rej) => {
        const vm = this
        let findingKpi = function(kpicon, indexk) {          
          return new Promise((resolve, reject) => {
            vm.businessTypeById(kpicon.business_type).then((businesstype) => {
              vm.getKpiById(kpicon.kpi).then((kpi) => {
                vm.getTravelById(kpicon.travel).then((travel) => {
                  vm.getSegmentById(kpicon.segment).then((segment) => {
                    vm.getProductById(kpicon.product).then((product) => {
                      vm.collabsPlans[index].kpicon[indexk].kpi = kpi
                      vm.collabsPlans[index].kpicon[indexk].travel = travel
                      vm.collabsPlans[index].kpicon[indexk].segment = segment
                      vm.collabsPlans[index].kpicon[indexk].product = product
                      vm.collabsPlans[index].kpicon[indexk].business_type = businesstype
                      for (let s of vm.states) {                
                        if (vm.collabsPlans[index].kpicon[indexk].state == s._id.toString()) {
                          vm.collabsPlans[index].kpicon[indexk].state = s
                        }
                      }
                      resolve()    
                    }, (error) => {
                      console.info(error)
                      reject(error)  
                    })
                  }, (error) => {
                    console.info(error)
                    reject(error)  
                  })
                }, (error) => {
                  console.info(error)
                  reject(error)  
                })              
              }, (error) => {
                console.info(error)
                reject(error)
              })
            }, (error) => {
              console.info(error)
              reject(error)
            })
          })
        }

        let actionsk = vm.collabsPlans[index].kpicon.map(findingKpi)
        let results = Promise.all(actionsk)
        results.then(() => {
          res()
        }, (err) => {
          rej(err)
        })
      })      
    },
    getStatesPerWc(index) {
      return new Promise((resolve, reject) => {
        const vm = this
        try {
          for (let indexwc in vm.collabsPlans[index].weekly_challenge) {
            for (let s of vm.states) {
              if (vm.collabsPlans[index].weekly_challenge[indexwc].state == s._id) {
                vm.collabsPlans[index].weekly_challenge[indexwc].state = s
              }
            }
          }
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    getPlanInfo(index) {      
      return new Promise((resolve, reject) => {
        const vm = this
        vm.getsKpisPerPlan(index).then((response) => {
          vm.getsCatPdPerPlan(index).then((resp) => {
            vm.getsSubcatPdPerPlan(index).then((res) => {
              vm.getStatesPerWc(index).then((r) => {
                resolve()
              }, (ee) => {
                reject(ee)
              })              
            }, (e) => {
              reject(e)
            })
          }, (err) => {
            reject(err)
          })
          // resolve()
        }, (error) => {
          reject(error)          
        })
      })
    },
    getDetailsLiderPLans() {
      const vm = this
      return new Promise((res, rej) => {
        let getdetails = function (plan, index) {
          return new Promise((resolve, reject) => {
            vm.getPlanInfo(index).then((response) => {
              resolve()
            }, (error) => {
              reject(error)
            })
          })
        }
        let actionsPerPlan = vm.collabsPlans.map(getdetails)
        let results = Promise.all(actionsPerPlan)
        results.then(() => {
          res()
        }, (error) => {
          rej(error)
        })
      })      
    },
    getStates() {
      return new Promise((resolve, reject) => {
        const vm = this
        vm.statesList().then((response) => {
          vm.states = vm.$store.getters["State/getStates"]
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    checkAc(element) {
      const vm = this
      let accomplished = ''
      let ok = true

      switch (element) {
        case 'weekly_challenge':
          accomplished = 'accomplishedWC'
          break
        case 'personal_development':
          accomplished = 'accomplishedPD'
          break
        case 'kpicon':
          accomplished = 'accomplishedK'
          break
      }

      for (let index in vm.currentPL[element]) {
        if (vm[accomplished][index] == null) {
          if (vm.currentPL[element][index].hasOwnProperty('_id')) {
            ok = false
          }
        } else {
          vm.currentPL[element][index].accomplished = vm[accomplished][index]
        }
      }

      return ok
    },
    upadteWC(type) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando...')
      
      vm.addCommentToLiderPlan(type).then(() => {
        vm.updateBWeeklyChallenge({
          data: vm.currentPL.weekly_challenge,
          lider_plan: vm.currentPL._id
        }).then((plupdated) => {
          vm.errorWC = false
          vm.commentToSend = null
          vm.collabsPlans[vm.currentPLindex].weekly_challenge = plupdated
          loading.hide()
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Desafio semanal agregado',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          vm.errorWC = false
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })        
      
    },
    updatePD(type) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando...')
      
      vm.addCommentToLiderPlan(type).then(() => {
        vm.updateBPersonalDevelopment({
          data: vm.currentPL.personal_development,
          lider_plan: vm.currentPL._id
        }).then((plupdated) => {
          vm.errorPD = false
          vm.commentToSend = null
          vm.collabsPlans[vm.currentPLindex].personal_development = plupdated
          loading.hide()
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Desarrollo personal agregado',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    updateK(type) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando...')
      
      vm.addCommentToLiderPlan(type).then(() => {
        vm.updateBKpiCon({
          data: vm.currentPL.kpicon,
          lider_plan: vm.currentPL._id
        }).then((plupdated) => {
          vm.commentToSend = null
          vm.errorK = false
          vm.collabsPlans[vm.currentPLindex].kpicon = plupdated
          loading.hide()
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Kpi agregado',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          }) 
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    showUpdateConfirm(type, message) {
      const vm = this
      this.$dialog
      .confirm(`Desea grabar ${message}`, {okText: 'Continuar', cancelText: 'Cancelar'})
      .then(function(dialog) {
        switch(type) {
          case 'updatePD':
            vm.updatePD('Desarrollo Personal')
            break;
          case 'upadteWC':
            vm.upadteWC('Desafio Semanal')
            break;
          case 'updateK':
            vm.updateK('Kpi')
            break;
        }
      })
      .catch(function() {
        console.log('Clicked on cancel');
      });
    },
    showCloseConfirm(type, message, obj, planid, ind) {
      const vm = this      
      this.$dialog
      .confirm(`Desea cerrar ${message}`, {okText: 'Continuar', cancelText: 'Cancelar'})
      .then(function(dialog) {
        switch(type) {
          case 'closePD':
            vm.closePD(obj, planid, ind)
            break;
          case 'closeWC':
            vm.closeWC(obj, planid, ind)
            break;
        }
      })
      .catch(function(e) {
        console.log(e);
        console.log('Clicked on cancel');
      });
    },
    updateLiderIca(id, ica) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando ICA...')
      vm.updateIca({id: id, ica: ica}).then((response) => {
        loading.hide()
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'ICA actualizado',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    travelsByRole() {
      return new Promise((resolve, reject) => {
        const vm = this
        vm.getTravelsByRoles({roles: vm.currentPL.lider.role}).then(() => {
          vm.travels = vm.$store.getters['travel/getTravels']
          resolve();
        }, (error) => {
          reject(error);
        });
      });
    }
  },
  watch: {
    drawerComentarios: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawerDesafio: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawerKpi: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawerObjetivos: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    currentStep: function() {
      const vm = this
      let complete = true
      for (let c of vm.collabsPlans) {
        if (c.kpicon.length <= 1 ||
          c.personal_development.length <= 1 ||
          c.weekly_challenge.length <= 1) {
          complete = false
        }
      }
      console.log(complete)
      if (complete) {
        vm.$emit('completed-step', {value: true});
        vm.$emit("can-continue", { value: true });
      } else {
        vm.$emit("can-continue", { value: false });
      }
    }
  },
  updated() {
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.plan_con = vm.$store.getters['plan_con/getPlan']    
    vm.getCategories()
    vm.createIfDontExist(vm.user.id).then(response => {
      vm.collabs = vm.$store.getters['plan_lider/getCollabs']      
      vm.collabsPlanWeekInfo({collabs: vm.collabs}).then(response => {
        vm.collabsPlans = vm.$store.getters['plan_lider/getCollabsPlan']
        vm.addControlLider()
        vm.checkManagment()
        vm.getStates().then(() => {
          vm.getDetailsLiderPLans().then(() => {
            loading.hide()
          }, (err) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: err,
              closeable: true,
              duration: 5000
            })
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })          
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })    
  }
};
</script>
<style lang="stylus" scoped>
  .desafios-semanales
    &:nth-child(2)
      .col-12
        & > [class^='col']
          padding-top 0!important
    &:last-child
      .col-12
        & > [class^='col']
          border 0!important
          padding-bottom 0!important
    
</style>


// WEBPACK FOOTER //
// src/views/ps-consultor-externo-lideresasignados.vue